import { Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { PlanCategory } from '@/shared/types/Billing';

import { SContainer, STextContainer } from './styled';

export type MinutesTextProps = {
  category: PlanCategory;
  value: number | string;
};

export const MinutesText = ({ category, value }: MinutesTextProps) => {
  const minutes = typeof value === 'number' ? `${value} minutes included` : value;

  const isEnterprise = category === PlanCategory.Enterprise;

  return (
    <Stack alignSelf="center">
      <SContainer>
        <STextContainer>
          <Typography color={isEnterprise ? 'common.white' : 'grey.700'} variant="caption-1-md">
            {minutes}
          </Typography>
        </STextContainer>
      </SContainer>
    </Stack>
  );
};
